/* Guide heading fold (Website, 7 Oct 2026). Clarity, 3 days running: readers tap guide H2s expecting them to open or close
   (7 Oct: 3 dead clicks + 5 mis-taps in 5 sessions, e.g. 1055164267:1916377244 tapped 'Ear positions' 3 times in 11 s).
   Every section stays OPEN by default, so reading, search and no-JS visitors see the full guide as before. A tap on an H2
   folds or unfolds the content up to the next H2. Links inside headings keep working. Event: rn_guide_fold {state, heading}. The tap target is a button inside the H2, so heading navigation still works. */
(function () {
  var roots = document.querySelectorAll('.ntg__rte, .nta__rte');
  if (!roots.length) return;
  var st = document.createElement('style');
  st.textContent = '.ntg-fb{all:unset;box-sizing:border-box;width:100%;cursor:pointer;display:flex;align-items:flex-start;justify-content:space-between;gap:16px;font:inherit;color:inherit;letter-spacing:inherit;line-height:inherit}' +
    '.ntg-fb::after{content:"";flex:none;width:11px;height:11px;margin-top:.45em;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);transition:transform .2s;opacity:.55}' +
    '.ntg-fb[aria-expanded="false"]::after{transform:rotate(-45deg)}' +
    '.ntg-fb:focus-visible{outline:2px solid var(--pt,#0F5F73);outline-offset:4px}';
  document.head.appendChild(st);
  var SKIP = '.rn-guide-product-route, .rn-content-shop-next, .quick-summary, .ntg-shop, details';
  function isStop(el) {
    if (el.tagName === 'H2') return true;
    var nx = el.nextElementSibling;
    return el.classList.contains('ntg-anc') && nx && nx.tagName === 'H2';
  }
  roots.forEach(function (root) {
    var hs = Array.prototype.filter.call(root.querySelectorAll('h2'), function (h) { return !h.closest(SKIP) && !h.querySelector('a'); });
    if (hs.length < 2) return;
    hs.forEach(function (h, i) {
      var body = [], n = h.nextElementSibling;
      while (n && !isStop(n)) { body.push(n); n = n.nextElementSibling; }
      if (!body.length) return;
      var wrap = document.createElement('div');
      wrap.className = 'ntg-fold';
      wrap.id = 'ntg-fold-' + i;
      h.parentNode.insertBefore(wrap, body[0]);
      body.forEach(function (el) { wrap.appendChild(el); });
      h.classList.add('ntg-fh');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ntg-fb';
      b.setAttribute('aria-expanded', 'true');
      b.setAttribute('aria-controls', wrap.id);
      while (h.firstChild) b.appendChild(h.firstChild);
      h.appendChild(b);
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        wrap.hidden = open;
        try { window.ntEvent && window.ntEvent('rn_guide_fold', { state: open ? 'closed' : 'open', heading: (b.textContent || '').trim().slice(0, 80) }); } catch (e) {}
      });
    });
  });
  // A contents link or #hash into a folded section opens it first.
  function openFor(id) {
    var t = id && document.getElementById(id);
    if (!t) return;
    if (t.classList.contains('ntg-anc') && t.nextElementSibling) t = t.nextElementSibling;
    var w = t.classList.contains('ntg-fh') ? t.nextElementSibling : t.closest('.ntg-fold');
    if (w && w.classList.contains('ntg-fold') && w.hidden) { var bb = w.previousElementSibling && w.previousElementSibling.querySelector('.ntg-fb'); if (bb) bb.setAttribute('aria-expanded', 'true'); w.hidden = false; }
  }
  window.addEventListener('hashchange', function () { openFor(location.hash.slice(1)); });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (a) openFor(a.getAttribute('href').slice(1));
  }, true);
})();
